import { WrenchIcon } from "@phosphor-icons/react";

import { Wrapper, Card, Title, Subtitle } from "./MaintenanceWindow.styles";
import type { SxProps, Theme } from "@mui/material";

export function MaintenanceWindow({
  title = "Unavailable for maintenance",
  subtitle = "Broadcasts are temporarily unavailable while we make some improvements. Please check back soon.",
  sx,
}: {
  title?: string;
  subtitle?: string;
  sx?: SxProps<Theme>;
}) {
  return (
    <Wrapper sx={sx}>
      <Card
        animate={{ opacity: [1, 0.5, 1] }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        <WrenchIcon size={48} color="white" weight="duotone" />
        <Title variant="h6">{title}</Title>
        <Subtitle variant="body2">{subtitle}</Subtitle>
      </Card>
    </Wrapper>
  );
}
